import { createFileRoute } from "@tanstack/react-router";

import { AdminCostTracking } from "@/features/admin";

/**
 * URL contract — the cost-trace drill-down is URL-addressable via
 * ``?trace=<trace_id>`` (Jul 2026). When set, ``AdminCostTracking`` renders the
 * inline ``CostTraceDetailSection`` takeover (LLM-call waterfall) in place of
 * the dashboard list; browser back / refresh / deep-links all work. The param
 * is OPTIONAL — an unknown/missing value coerces to ``undefined`` so existing
 * ``/admin/cost-tracking`` links stay valid.
 */
interface CostTrackingSearch {
  readonly trace?: string;
}

export const Route = createFileRoute("/_authed/_modal/admin/cost-tracking")({
  component: AdminCostTracking,
  validateSearch: (raw: Record<string, unknown>): CostTrackingSearch => {
    const trace = typeof raw.trace === "string" && raw.trace.length > 0 ? raw.trace : undefined;
    return { trace };
  },
});
